
import { Component, Prop, Vue } from "vue-property-decorator";
import FormItem from "@/components/DocumentViewCards/views/Card/components/forms/FormItem.vue";
import { ICOSForm } from "@/models/COS";
import { validateDate } from "@/utils/dates";

@Component({
  components: { FormItem },
})
export default class FormCOSCompliance extends Vue {
  @Prop({ type: Boolean, default: false }) readonly loading?: boolean;
  @Prop({ type: Object, required: true }) readonly details!: any;

  options = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  optionsYear = [
    { value: "Contract", label: "Contract" },
    { value: "Day", label: "Day" },
    { value: "Hour", label: "Hour" },
    { value: "Week", label: "Week" },
    { value: "Month", label: "Month" },
    { value: "Year", label: "Year" },
  ];

  confirm() {
    this.$emit("confirm", this.form);
  }

  setCosDate(date: string) {
    return date && validateDate(date) ? date : "";
  }

  created() {
    this.setCosForm(this.details);
  }

  getOtherWorkAddressesHeader(index, items) {
    const OTHER_WORK_ADDRESSES_HEADER = "Other regular work addresses in the UK";

    if (!items.length || items.length === 1) return OTHER_WORK_ADDRESSES_HEADER;

    return `${OTHER_WORK_ADDRESSES_HEADER} [${index + 1}]`;
  }

  setCosForm(data: ICOSForm) {
    this.form = {
      ...this.form,
      ...data,
      cos_issue_date: this.setCosDate(data.cos_issue_date),
      cos_expiry_date: this.setCosDate(data.cos_expiry_date),
      cos_work_start_date: this.setCosDate(data.cos_work_start_date),
      cos_work_end_date: this.setCosDate(data.cos_work_end_date),
      date_of_birth: this.setCosDate(data.date_of_birth),
    };
  }

  form: ICOSForm = {
    cos_tier: "",
    cos_sponsor_licence_number: "",
    cos_sponsor_name: "",
    cos_number: "",
    cos_issue_date: "",
    cos_expiry_date: "",
    cos_note: "",
    cos_last_name: "",
    cos_first_name: "",
    cos_other_name_n_: "",
    cos_nationality_n_: "",
    place_of_birth: "",
    country_of_birth: "",
    date_of_birth: "",
    gender: "",
    national_insurance_number: "",
    employee_number: "",
    cos_work_start_date: "",
    cos_work_end_date: "",
    if_to_leave_uk: false,
    hours_work: "",
    job_title: "",
    job_type: "",
    job_description: "",
    if_client_contract: false,
    client_contract_details: "",
    basic_salary: "",
    migrant_salary_for_each: "",
    salary_and_allowances: "",
    allowances: "",
    job_title_shortage_list: false,
    maintenance_status: false,
    registration_details: "",
    atas_required: false,
    phd_required_for_post: false,
    if_passed_rlmt: false,
    work_address: null,
    other_work_addresses: [],
  };
}
